import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {getContactOrgId} from '../BusinessActivateNiudBlock/constants';
import {getContactCompanyList} from '../PortalsBlock/portalSlice';
import {CHECK_NIUD_STATUS_ERROR_MESSAGES} from './constants';

const resolveContactOrgId = (state, data) => {
  return getContactOrgId(state.portalsBlock) || data.contactOrgId;
};

export const checkNiudStatus = createAsyncThunk('BusinessCheckNiudStatusSlice/checkNiudStatus', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    let contactOrgId = resolveContactOrgId(thunkAPI.getState(), data);

    if (!contactOrgId) {
      const {portalsBlock, authentication} = thunkAPI.getState();
      if (authentication?.loginData?.isFullAuthenticated && !portalsBlock.requestCompleted) {
        await thunkAPI.dispatch(getContactCompanyList());
        contactOrgId = resolveContactOrgId(thunkAPI.getState(), data);
      }
    }

    if (!contactOrgId) {
      thunkAPI.dispatch(hideAppLoader());
      return {
        isValid: false,
        errorCode: 'OrgIdNotFound',
        errorMessage: CHECK_NIUD_STATUS_ERROR_MESSAGES.OrgIdNotFound,
      };
    }

    const result = await ProviderManager.getProviderData('checkNiudStatus', [data.niudNumber, contactOrgId]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {serverError: true};
  }
});

const initialState = {
  formErrors: {},
  apiError: null,
  apiErrorMessage: null,
  requestedPortTime: null,
  statusMessage: null,
  statusType: null,
};

const BusinessCheckNiudStatusSlice = createSlice({
  name: 'BusinessCheckNiudStatusSlice',
  initialState,
  reducers: {
    setFormErrors: (state, action) => {
      state.formErrors = action.payload;
    },
    clearApiError: (state) => {
      state.apiError = null;
      state.apiErrorMessage = null;
      state.requestedPortTime = null;
      state.statusMessage = null;
      state.statusType = null;
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(checkNiudStatus.fulfilled, (state, action) => {
      if (action.payload?.serverError) {
        state.apiError = 'GeneralError';
        state.apiErrorMessage = null;
        state.requestedPortTime = null;
        state.statusMessage = null;
        state.statusType = null;
        return;
      }

      if (action.payload?.isValid) {
        state.apiError = null;
        state.apiErrorMessage = null;
        state.requestedPortTime = action.payload.requestedPortTime || null;
        state.statusMessage = action.payload.statusMessage || null;
        state.statusType = action.payload.statusType || null;
      } else {
        state.apiError = action.payload?.errorCode || 'GeneralError';
        state.apiErrorMessage = action.payload?.errorMessage || null;
        state.requestedPortTime = null;
        state.statusMessage = null;
        state.statusType = null;
      }
    });
  },
});

export const {setFormErrors, clearApiError, resetState} = BusinessCheckNiudStatusSlice.actions;
export default BusinessCheckNiudStatusSlice.reducer;
